import { Autocomplete, Avatar, Backdrop, Button, Checkbox, Chip, Divider, FormControlLabel, Grid, IconButton, Switch, TextField, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import Modal from "../../../../../components/utils/modal/modal";
import * as yup from 'yup'
import { useFormik } from 'formik'
import CustomTextField from "../../../../../components/utils/input/customTextField";
import CustomdropDown from "../../../../../components/utils/dropDown/customdropDown";
import State from "../../../../../components/utils/dropDown/state";
import Country from "../../../../../components/utils/dropDown/country";
import City from "../../../../../components/utils/dropDown/city";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import _ from "lodash";
import { Delete, EditNote, Visibility } from "@mui/icons-material";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import moment from "moment";
import Loader from "../../../../../components/loader/loader";
import DropZone from "../../../../../components/utils/dropZone/dropZone";
import DropImg from "../../../../../components/utils/dropZone/dropImg";
import DropPassBook from "../../../../../components/utils/dropZone/dropPassbook";
import { Box } from "@mui/system";
import useStyle from "./style";
import { Helmet } from "react-helmet-async";

const SalesMan = () => {
  const dispatch = useDispatch()
  const classes = useStyle()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [active, setActive] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [isLoader, setIsLoader] = useState(false); //loader
  const [previewImg, setPreviweImg] = useState(null);
  const [previewImgId, setPreviweImgId] = useState(null);
  const [previewImgBook, setPreviweImgBook] = useState(null);
  const [openLogo, setOpenLogo] = useState(false);
  const [openLogoId, setOpenLogoId] = useState(false);
  const [openLogoBook, setOpenLogoBook] = useState(false);
  const [outletData, setOutletData] = useState([])
  const validation = yup.object({
    img:previewImg === null
    ? yup.array().notRequired()
    : yup.array().notRequired(),
    logo:
      previewImg === null
        ? yup.array().notRequired()
        : yup.array().notRequired(),
    passBook:
    previewImg === null
      ? yup.array().notRequired()
      : yup.array().notRequired(),
    salesmanCode: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    salesmanName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    Dob:yup
    .date('Invalid date')
    .required('This field is required'),
    gender: yup.object().required(),
    fatherName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    motherName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    address1: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    address2: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
     phone: yup.string().matches(/^\S.*$/, "Empty space not allowed!") .matches(/^\d+$/, "Only digits are allowed")
    .required('This field is required!'),
    outlet: yup.array().min(1),
  })

  const formik = useFormik({
    initialValues:{
      img:[],
      logo: [],
      passBook:[],
      salesmanCode:'',
      salesmanName:"",
      Dob:"",
      gender:null,
      fatherName:"",
      motherName:"",
      address1:"",
      address2:"",
      phone:"",
      outlet:[]
    },
    validationSchema: validation,
    onSubmit : isEdit ? handleUpdate : handleCreate
  })
  const customHeader = {
    "Content-Type": "multipart/form-data",
  };
  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "name",
      headerName: "Salesman Name",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "gender",
      headerName: "Gender",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "phone",
      headerName: "Phone No.",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "add1",
      headerName: "Address 1",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    
    {
      field: "add2",
      headerName: "Address 2",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "photo",
      minWidth: 180,
      minWidth: 50,
      headerName: "Photo",
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Grid className={classes.logoGrid}>
            <Avatar
              className={classes.companyLogo}
              src={`${process.env.REACT_APP_IMG_URL}/${params.row.photo}`}
            />
            <Box>
              <IconButton onClick={() => handlePreview(params.row.photo)}>
                <Visibility />
              </IconButton>
            </Box>
          </Grid>
        );
      },
    },
    {
      field: "id_proof",
      minWidth: 180,
      minWidth: 50,
      headerName: "Id Proof",
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Grid className={classes.logoGrid}>
            <Avatar
              className={classes.companyLogo}
              src={`${process.env.REACT_APP_IMG_URL}/${params.row.id_proof}`}
            />
            <Box>
              <IconButton onClick={() => handlePreviewId(params.row.id_proof)}>
                <Visibility />
              </IconButton>
            </Box>
          </Grid>
        );
      },
    },
    {
      field: "passbook",
      minWidth: 180,
      minWidth: 50,
      headerName: "Pass Book",
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Grid className={classes.logoGrid}>
            <Avatar
              className={classes.companyLogo}
              src={`${process.env.REACT_APP_IMG_URL}/${params.row.passbook}`}
            />
            <Box>
              <IconButton onClick={() => handlePreviewBook(params.row.passbook)}>
                <Visibility />
              </IconButton>
            </Box>
          </Grid>
        );
      },
    },
    {
      field: "isActive",
      headerName: "Status",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="">
      <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Inactive'}/>
      </div>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      minWidth: 180,
      minWidth: 100,
      disableExport: true ,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className='flex justify-center w-full'>
          <IconButton onClick={()=>onEdit(params.row)} >
            <EditNote sx={{color:"#1972d2",fontSize:22}}/>
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{color:"red",fontSize:22}}/>
          </IconButton>
        </div>
      ),
    },
  ];

  const rows = _.map(data,(val,idx)=>({
    id: val.id,
    sno: ++idx,
    name: val.sales_man_name,
    code: val.sales_man_code,
    add1: val.add1,
    add2: val.add2,
    add3: val.add3,
    fatherName: val.father_name,
    motherName : val.mother_name,
    dob: val.dob,
    companyId : val.company_id,
    isActive: val.is_active,
    profile: val.photo,
    phone: val.mobile,
    gender: val.sex,
    photo:val.photo,
    id_proof:val.id_proof,
    passbook:val.passbook,
    outlet_ids : val.outlets

  }))

  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch : setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };
  const getOutletData = () =>{
    setIsLoader(true)
  
    axios.get('/v1/outlet/list/1')
    .then(res=>{
      setOutletData(res.data)
    setIsLoader(false)
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
      setIsLoader(false)
    })
  }
  const genderList = [
    {id:'male', label:"Male"},
    {id:'female',label:"Female"},
    {id:'transgender',label:"Transgender"},

]
const handlePreview = (e) => {
  console.log(e)
  setOpenLogo(true);
  setPreviweImg(`${process.env.REACT_APP_IMG_URL}/${e}`);
};
const handlePreviewId = (e) => {
  setOpenLogoId(true)
  setPreviweImgId(`${process.env.REACT_APP_IMG_URL}/${e}`)
}
const handlePreviewBook = (e) => {
  console.log(e)
  setOpenLogoBook(true)
  setPreviweImgBook(`${process.env.REACT_APP_IMG_URL}/${e}`)
}
const onCreate = ()=>{
  setOpen(true)
  formik.resetForm()
  setIsEdit(false)
  }

  function handleCreate () {
    const formData = new FormData()
    formData.append("sales_man_code" ,formik.values.salesmanCode)
    formData.append("sales_man_name" ,formik.values.salesmanName)
    formData.append("short_name" ,"-")
    formData.append("company_id" ,1)
    formData.append("code" ,formik.values.salesmanCode)
    formData.append("mobile" ,formik.values.phone)
    formData.append("dob" ,moment( formik.values.Dob).format('DD-MM-YYYY'))
    formData.append("sex" ,formik.values.gender.id)
    formData.append("is_active" ,active)
    formData.append("add1" ,formik.values.address1)
    formData.append("add2" ,formik.values.address2)
    formData.append("add3" ,"-")
    formData.append("father_name" ,formik.values.fatherName)
    formData.append("mother_name" ,formik.values.motherName)
    const outletArr = _.map(formik.values.outlet, val=>({
      outlet_ids : val.id
    }))
    const formattedString = outletArr.map(item => item.outlet_ids).join(',')
    console.log(formattedString);
    formData.append('outlet_ids' ,  formattedString)
    if (formik.values.logo.length > 0) {
      formData.append("photo", formik.values.logo[0]);
    } else {
      formData.append("photo", null);
    }
  
    if (formik.values.img.length > 0) {
      formData.append("id_proof", formik.values.img[0]);
    } else {
      formData.append("id_proof", null);
    }
  
    if (formik.values.passBook.length > 0) {
      formData.append("passbook", formik.values.passBook[0]);
    } else {
      formData.append("passbook", null);
    }
    // formData.append("photo" ,formik.values.logo[0] )
    // formData.append("id_proof", formik.values.img[0] )
    // formData.append("passbook", formik.values.passBook[0] )

//  const salesData = {
//   sales_man_code: formik.values.salesmanCode,
//   sales_man_name : formik.values.salesmanName,
//   company_id:1,
//   code:formik.values.salesmanCode,
//   mobile:formik.values.phone,
//   dob: moment( formik.values.Dob).format('DD-MM-YYYY'),
//   sex:formik.values.gender.id,
//   photo:"https://www.w3schooles.com",
//   is_active: active,
//   add1:formik.values.address1,
//   add2:formik.values.address2,
//   add3:"-",
//   father_name: formik.values.fatherName,
//   mother_name: formik.values.motherName
// }
setIsLoader(true);
console.log(formik.values)
axios.post('/v1/SalesMan/outlet_mapping', formData , {
  headers: customHeader,
})
.then(res=>{
  getSalesData()
  setOpen(false)
  dispatch(setSnackbar(true, 'success', 'Created Successfully'))
  setIsLoader(false);
})
.catch(err=>{
  dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
  setIsLoader(false);
})
  }

  function onEdit(e){
    console.log(e)
    formik.setFieldValue('salesmanCode',e.code)
    formik.setFieldValue('Dob',e.dob)
    formik.setFieldValue('salesmanName',e.name)
    formik.setFieldValue('Dob',moment(e.dob, 'DD-MM-YYYY').format('YYYY-MM-DD'))
    formik.setFieldValue('fatherName',e.fatherName)
    formik.setFieldValue('motherName',e.motherName)
    formik.setFieldValue('address1',e.add1)
    formik.setFieldValue('address2',e.add2)
    formik.setFieldValue('address3',"-")
    formik.setFieldValue('phone',e.phone)
    _.filter(genderList,val=>val.id === e.gender).map(val=>formik.setFieldValue('gender',val))
    setIsEdit(true)
    setOpen(true)
    setActive(e.isActive)
    setActiveId(e.id)
    setPreviweImg(e.photo)
    setPreviweImgId(e.id_proof)
    setPreviweImgBook(e.passbook)
    const outArr = e.outlet_ids
      const filteredOutletData = outArr.map((outlet) => {
        const matchingOutlet = outletData.find((data) => data.id === outlet.id);
        return {
          ...matchingOutlet,
        }
      })
    formik.setFieldValue('outlet', filteredOutletData)

    }

function handleUpdate(){
  const formData = new FormData()
    formData.append("sales_man_code" ,formik.values.salesmanCode)
    formData.append("sales_man_name" ,formik.values.salesmanName)
    formData.append("short_name" ,"-")
    formData.append("company_id" ,1)
    formData.append("code" ,formik.values.salesmanCode)
    formData.append("mobile" ,formik.values.phone)
    formData.append("dob" ,moment( formik.values.Dob).format('DD-MM-YYYY'))
    formData.append("sex" ,formik.values.gender.id)
    formData.append("is_active" ,active)
    formData.append("add1" ,formik.values.address1)
    formData.append("add2" ,formik.values.address2)
    formData.append("add3" ,"-")
    formData.append("father_name" ,formik.values.fatherName)
    formData.append("mother_name" ,formik.values.motherName)
    const outletArr = _.map(formik.values.outlet, val=>({
      outlet_ids : val.id
    }))
    const formattedString = outletArr.map(item => item.outlet_ids).join(',')
    console.log(formattedString);
    formData.append('outlet_ids' ,  formattedString)
    // formData.append("photo",formik.values.logo ?  formik.values.logo[0] : null)
    // formData.append("photo","red.avif")
    // formData.append("id_proof",formik.values.img ?  formik.values.img[0] : null)
    // formData.append("passbook",formik.values.passBook ?  formik.values.passBook[0] : null)
   
    previewImg !== null
    ? formData.append(
        "photo",
        previewImg
        // `${process.env.REACT_APP_IMG_URL}/${previewImg}`
      )
    : formData.append("photo", formik.values.logo[0]);
    // if (formik.values.logo.length > 0) {
    //   formData.append("photo", formik.valu es.logo[0]);
    // } else {
    //   formData.append("photo", null);
    // }
    previewImgId !== null
    ? formData.append(
        "id_proof",
        previewImgId
        // `${process.env.REACT_APP_IMG_URL}/${previewImgId}`
      )
    : formData.append("id_proof", formik.values.img[0]);
    // if (formik.values.img.length > 0) {
    //   formData.append("id_proof", formik.values.img[0]);
    // } else {
    //   formData.append("id_proof", null);
    // }
    previewImgBook !== null
    ? formData.append(
        "passbook",
        previewImgBook 
        // `${process.env.REACT_APP_IMG_URL}/${previewImgBook}`
      )
    : formData.append("passbook", formik.values.passBook[0]);
    // if (formik.values.passBook.length > 0) {
    //   formData.append("passbook", formik.values.passBook[0]);
    // } else {
    //   formData.append("passbook", null);
    // }
  // const salesData = {
  //   sales_man_code: formik.values.salesmanCode,
  //   sales_man_name : formik.values.salesmanName,
  //   company_id:1,
  //   code:formik.values.salesmanCode,
  //   mobile:formik.values.phone,
  //   dob: moment( formik.values.Dob).format('DD-MM-YYYY'),
  //   sex:formik.values.gender.id,
  //   photo:"https://www.w3schooles.com",
  //   is_active: active,
  //   add1:formik.values.address1,
  //   add2:formik.values.address2,
  //   add3:"-",
  //   father_name: formik.values.fatherName,
  //   mother_name: formik.values.motherName
  // }
  setIsLoader(true);
  console.log(activeId)
  axios.put(`/v1/SalesMan/outlet_mapping/${activeId}`, formData , {
    headers: customHeader,
  })
  .then(res=>{
    getSalesData()
    setOpen(false)
    dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
    setIsLoader(false);
  })
  .catch(err=>{
    dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
    setIsLoader(false);
  })
}
    function OnDelete(id){
      setOpenDialog(true)
      setActiveId(id)
    }  
    
    const handleDelete = () =>{
      setIsLoader(true);
      axios.delete(`/v1/SalesMan/${activeId}`)
      .then(res=>{
        setOpenDialog(false)
        getSalesData()
        console.log(res)
        dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
        setIsLoader(false);
        setOpen(false)
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    }

const getSalesData = () =>{
  setIsLoader(true);
  const url = `/v1/SalesMan/outlet_mapping/${rowsPerPage}/${page + 1}`
  const searchUrl = `/v1/SalesMan/outlet_mapping/${rowsPerPage}/${page + 1}/${search}`
  axios.get(search === '' ? url : searchUrl)
  .then(res=>{
    console.log(res)
    setData(res.data.data)
    setPageCount(res.data.meta.pagination.total)
    setIsLoader(false);
  })
  .catch(err=>{
    dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
    setIsLoader(false);
  })
}
useEffect(() => {
  getOutletData()
},[])
useEffect(()=>{
getSalesData()
},[rowsPerPage,  page, search])


const handlePhone =(e)=>{
  formik.setFieldValue('phone', e.target.value.replace(/\D/g, "").trim())
}
  return (
    <Fragment>
      <Helmet>
        <title>Salesman</title>
      </Helmet>
      <Typography variant="h5">Salesman</Typography>
      {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
{open &&
<Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
    <Grid container spacing={2}>
      <Grid item xs={12}> <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>1. Company Details</Typography></Grid>
      <Grid item xs={12} md={4} lg={3}>
        <CustomTextField id='salesmanCode' value={formik.values.salesmanCode} title='Biometric Code' multiple={false} placeholder='Enter Salesman code' onchange={formik.handleChange} errorMsg={formik.touched.salesmanCode && Boolean(formik.errors.salesmanCode)} helperText={formik.touched.salesmanCode && formik.errors.salesmanCode}/>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <CustomTextField id='salesmanName' value={formik.values.salesmanName} title='Salesman Name' multiple={false} placeholder='Enter Salesman Name' onchange={formik.handleChange} errorMsg={formik.touched.salesmanName && Boolean(formik.errors.salesmanName)} helperText={formik.touched.salesmanName && formik.errors.salesmanName}/>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <CustomTextField id='Dob' value={formik.values.Dob} title='Date of Birth' type="date" multiple={false} placeholder='Enter your DOB' onchange={formik.handleChange} errorMsg={formik.touched.Dob && Boolean(formik.errors.Dob)} helperText={formik.touched.Dob && formik.errors.Dob}/>
      </Grid>
      <Grid item xs={12} md={4} lg={3} >
              <CustomdropDown
                id="gender"
                data={genderList}
                optionLabel={(option) => option.label}
                value={formik.values.gender}
                onchange={(e, value) => {
                  formik.setFieldValue("gender", value);
                }}
                optionEqual={(option, value) => option.label === value.label}
                placeholder="Select gender"
                helperText={formik.touched.gender && formik.errors.gender}
                errorMsg={
                  formik.touched.gender && Boolean(formik.errors.gender)
                }
                title="Gender"
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='phone' value={formik.values.phone} title='Mobile' multiple={false} placeholder='Enter mobile No' onchange={handlePhone} errorMsg={formik.touched.phone && Boolean(formik.errors.phone)} helperText={formik.touched.phone && formik.errors.phone}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <Typography  variant='body1' fontSize={17} mb={0.8}>Salesman Profile</Typography>
            <DropZone formik={formik} previewImg={previewImg} setPreviweImg={setPreviweImg} isEdit={isEdit}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <Typography  variant='body1' fontSize={17} mb={0.8}>Salesman Id Proof's</Typography>
            <DropImg formik={formik} previewImgId={previewImgId} setPreviweImgId={setPreviweImgId} isEdit={isEdit}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <Typography  variant='body1' fontSize={17} mb={0.8}>Salesman Passbook </Typography>
            <DropPassBook formik={formik} previewImgBook={previewImgBook} setPreviweImgBook={setPreviweImgBook} isEdit={isEdit} />
            </Grid>
           
       <Divider />
       <Grid item xs={12} >
            <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>2. Family Details</Typography>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
        <CustomTextField id='fatherName' value={formik.values.fatherName} title='Father Name' multiple={false} placeholder='Enter Father Name' onchange={formik.handleChange} errorMsg={formik.touched.fatherName && Boolean(formik.errors.fatherName)} helperText={formik.touched.fatherName && formik.errors.fatherName}/>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <CustomTextField id='motherName' value={formik.values.motherName} title='Mother Name' multiple={false} placeholder='Enter Mother Name' onchange={formik.handleChange} errorMsg={formik.touched.motherName && Boolean(formik.errors.motherName)} helperText={formik.touched.motherName && formik.errors.motherName}/>
      </Grid>
      <Divider />
      <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>3. Address Info</Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='address1' value={formik.values.address1} title='Address 1' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address1 && Boolean(formik.errors.address1)} helperText={formik.touched.address1 && formik.errors.address1}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='address2' value={formik.values.address2} title='Address 2' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address2 && Boolean(formik.errors.address2)} helperText={formik.touched.address2 && formik.errors.address2}/>
    </Grid>
  <Grid item xs={12} md={4} lg={3} className="flex items-center">
      <FormControlLabel control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
    </Grid>
      <Grid item xs={12} >
  <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>5. Outlet Mapping</Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3} >
  <Autocomplete 
  id='outlet'
  name='outlet'
  size='small'
  options={outletData}
  getOptionLabel={(options)=>options.fullname}
  value={formik.values.outlet}
  onChange={(e,value)=> formik.setFieldValue('outlet', value)}
  fullWidth
  multiple={true}
  limitTags={3}
  isOptionEqualToValue={(option, value)=>option.fullname=== value.fullname}
  renderInput={(params)=>(
    <TextField 
    {...params}
    autoComplete='off'
    placeholder='Select Outlet'
    error={formik.touched.outlet && Boolean(formik.errors.outlet)}
    helperText={formik.touched.outlet && formik.errors.outlet}
    />
  )}
  />
        
      </Grid>
    </Grid>
  </Modal>
      }
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
       </Backdrop>
      <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#00000080",
          }}
          open={openLogo}
          onClick={() => setOpenLogo(false)}
        >
        <Grid className={classes.previewImage}>
          <Avatar
            variant="square"
            sx={{ objectFit: "contain" }}
            src={`${previewImg}`}
          />
          <Loader isLoader={isLoader} />
        </Grid>
      </Backdrop>
      <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#00000080",
          }}
          open={openLogoId}
          onClick={() => setOpenLogoId(false)}
        >
        <Grid className={classes.previewImage}>
          <Avatar
            variant="square"
            sx={{ objectFit: "contain" }}
            src={`${previewImgId}`}
          />
          <Loader isLoader={isLoader} />
        </Grid>
      </Backdrop>
      <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#00000080",
          }}
          open={openLogoBook}
          onClick={() => setOpenLogoBook(false)}
        >
        <Grid className={classes.previewImage}>
          <Avatar
            variant="square"
            sx={{ objectFit: "contain" }}
            src={`${previewImgBook}`}
          />
          {/* <Loader isLoader={isLoader} /> */}
        </Grid>
      </Backdrop>
{/* <Loader isLoader={isLoader}/> */}
    </Fragment>
  );
};

export default SalesMan;
